// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.archived-student-page section .table-container{margin:0 2rem 4rem 2rem}`, "",{"version":3,"sources":["webpack://./src/Pages/Student/ArchivedStudentPage/ArchivedStudentPage.style.scss"],"names":[],"mappings":"AACE,gDACE,uBAAA","sourcesContent":[".archived-student-page {\n  &  section .table-container {\n    margin : 0 2rem 4rem 2rem;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
